import React, { memo } from 'react'
import { useSelector } from 'react-redux'
import Route from 'route-parser'
import cx from 'classnames'
import { getBaseURI } from 'front-end-core/helpers/document'
import { URL_DATA } from 'constants/urls'
import selectAolName from 'redux/selectors/selectAolName'
import Icon from 'components/shared/Icon'
import TealToolTip from 'components/TealToolTip'

const dataRoute = (props) => getBaseURI() + new Route(URL_DATA).reverse(props)

const File = ({
  file: { id, title, description },
  isLast,
  isTrial,
  isLogged,
  setSignUpModalIsOpen
}) => (
  <li id={id} className={cx('pa6', { 'bb b--precedents-blue': !isLast })}>
    <div className='relative'>
      <PrecedentDownloadButton {...{ id, isLogged, setSignUpModalIsOpen }} />
      <FileContent title={title} description={description} />
    </div>
  </li>
)

export default File

const FileContent = ({ title, description }) => (
  <>
    <div className='flex items-center'>
      <div className='h-100'>
        <Icon className='w6 vm mb1' name='icon-file-document' />
      </div>
      <div className='b ml6 mr8' dangerouslySetInnerHTML={{ __html: title }} />
    </div>
    <FileDescription description={description} />
  </>
)

const FileDescription = ({ description }) => {
  const checkedDescription = description.replace(/(<([^>]+)>)/ig, '').length ? description : null

  return (
    <div className='description precedents-description ml8' dangerouslySetInnerHTML={{ __html: checkedDescription }} />
  )
}

const PrecedentDownloadButton = memo(({ id, isLogged, setSignUpModalIsOpen }) => {
  const aol = useSelector(selectAolName)
  const route = dataRoute({ aol, id })

  return (
    <div className='actions absolute right0 top0'>
      <TealToolTip title='Download' placement='left'>
        <a
          className='no-button bg-white pointer'
          data-help-item='precedentsdownload'
          data-help-position='left'
          data-event-category='Download'
          data-event-action='Print'
          data-event-label={route}
          {...(isLogged
            ? {
                href: route,
                download: 'FromCounsel - Selected content',
                target: '_blank',
                rel: 'noopener noreferrer'

              }
            : {
                onClick: () => setSignUpModalIsOpen(true)
              })}
        >
          <Icon className='w6' name='icon-download' />
        </a>
      </TealToolTip>
    </div>
  )
})
